
import './HousingCompanyDetailsTabs.scss';
import { FaArrowLeft, FaToggleOn, FaToggleOff} from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { useState,useEffect } from 'react';
import CompanyInformationServices from 'services/services/CompanyInformationServices';
import { Input, Modal, Form, Tooltip, message} from 'antd';
import { Button } from 'react-bootstrap';
import { convertToObjectKeyString, TranslateString } from 'Utils/Common';
import UserService from "services/UserService";
import { useParams } from 'react-router';
import HousingCompanyService from 'services/services/HousingCompanyService';

const HousingCompanyDetailsTabs = (props: any) => {
    const intl=useIntl();
    const [disabledShareholder, setDisabledShareholder] = useState<any>(null);
    const [disabledMonths, setDisabledMonths] = useState<any>(null);
    const [showShareholderDisable, setShowShareholderDisable] = useState<any>(false);
    const [isModalOpen, setIsModalOpen] = useState<any>(false);
    const [open, setOpen] = useState<any>(false);
    const [loading, setLoading] = useState<any>(false);
    const [updateDisableOpen, setUpdateDisableOpen] = useState<any>(false);
    const [disableOpen, setDisableOpen] = useState<any>(false);
    const params = useParams();
    const [disableMonthForm] = Form.useForm();
    const [extLoading, setExtLoading] = useState<any>(false);
    
    useEffect(() => {
       getCustomerDetails();
    }, []);

    let menus = [
        {
            key:1,
            label : "company_information",
            disableTab: false
        },
        {
            key:2,
            label : "financial_analysis",
            disableTab: props?.externalCustomer
        },
        {
            key:3,
            label : "shareholder_analysis",
            disableTab: disabledShareholder
        },
        {
            key:4,
            label : "ltv_analysis",
            disableTab: false

        },
        {
            key:5,
            label : "pts",
            disableTab: props?.externalCustomer
        }
    ];


    const getCustomerDetails = async () => {
        let object:any = {};
        object.customer_id=props?.id;
        await CompanyInformationServices
        .getCustomerData(object)
        .then((response:any) => {
            if(response?.data?.code===200){
                setDisabledShareholder(response?.data?.customer_data?.disable_shareholder)
                setShowShareholderDisable(response?.data?.customer_data?.show_disable_shareholder)
                if(response?.data?.customer_data?.loan_data_info && response?.data?.customer_data?.loan_data_info == 'external'){
                    props?.setExternalCustomer(true);
                }
                setExtLoading(true);
            }
        })
        .catch((err:any) => {
           console.log(err)
        });
    }

    const handleOk = (status:any) => {
        if(status == 'disable'){
            setDisableOpen(false);
            updateShareholderStatus({});
        } else {
            setOpen(false);
            setIsModalOpen(!isModalOpen);
        }
    }
    
    const handleCancelPop = () => {
        setOpen(false);
        setDisableOpen(false);
    };

    const updateShareholderStatus = async (formData:any) =>{
        setIsModalOpen(false);
        formData.created_by = UserService.getUserFullName();
        formData.customer_id = params?.id;
        if(showShareholderDisable){
            formData.is_active = 0;
        } else {
            formData.is_active = 1;
        }
        const updateShareholderStatus = await HousingCompanyService.updateShareholderStatus(formData)
        if(updateShareholderStatus?.data?.code===500){
            message.error(intl.formatMessage({id: convertToObjectKeyString(updateShareholderStatus?.data?.msg)}));
        }else if(updateShareholderStatus?.data?.code===200){
            message.success(intl.formatMessage({id: convertToObjectKeyString(updateShareholderStatus?.data?.msg)}));
            getCustomerDetails();
        }
    }


    const updateDisableDuration = async (formData:any) =>{
        setLoading(true);
        formData.created_by = UserService.getUserFullName();
        const updateDisableMonthsConfig = await HousingCompanyService.updateDisableMonthsConfig(formData)
        if(updateDisableMonthsConfig?.data?.code===500){
            message.error(intl.formatMessage({id: convertToObjectKeyString(updateDisableMonthsConfig?.data?.msg)}));
            setLoading(false);
        }else if(updateDisableMonthsConfig?.data?.code===200){
            setUpdateDisableOpen(false);
            setLoading(false);
            message.success(intl.formatMessage({id: convertToObjectKeyString(updateDisableMonthsConfig?.data?.msg)}));
            getCustomerDetails();
        }
    }

    const getDisabledMonths = async () => {
        let object:any = {};
        setLoading(true);
        await HousingCompanyService
        .getDisableMonthsConfig(object)
        .then((response:any) => {
            if(response?.data?.code===200){
                if(response?.data?.data?.key == 'disable_months'){
                    disableMonthForm.setFieldValue("disable_months", response?.data?.data?.value);
                    setLoading(false);
                } else {
                    disableMonthForm.setFieldValue("disable_months", 24);
                    setLoading(false);
                }
            } else if(response?.data?.code===500){
                message.error(intl.formatMessage({id: convertToObjectKeyString(response?.data?.msg)}));
                setLoading(false);
            }
        })
        .catch((err:any) => {
           console.log(err)
        });
    }

    return (
        <>
            <div className="site-card-wrapper">
                <div className={`row`}>
                    <div className={`col-md-12`}>
                        <div className="ant-card ant-card-bordered cu-mb-10 cu-ps-10 w-100 text-left cu-tab-text d-flex justify-space-between">
                            <Link to={`/housingcompany`}>
                                <h4 className="cu-m-0 cu-p-0">
                                    <button className="ant-btn cu-border-0 back-btn text-primary"><FaArrowLeft style={{ fontWeight: 900, fontSize: '28px' }} /></button>
                                    &nbsp;
                                    <button className="ant-btn cu-border-0 h4 pl-0 align-middle mb-0">{props?.id}-{props?.customer_name.replaceAll("----", "/")}</button>
                                </h4>
                            </Link>
                            <div>
                                <Tooltip className={`text-right`} title={TranslateString('update_disable_duration')}>
                                    <Button type="button" onClick={() => {setUpdateDisableOpen(true); getDisabledMonths()}} className="btn btn-sm cu-btn-green px-3 mr-1">{TranslateString('update_disable_duration')}</Button>
                                </Tooltip> 
                                { disabledShareholder && 
                                <Tooltip className={`text-right`} title={TranslateString('Re-activate Shareholder')}>
                                    <Button type="button" onClick={() => setOpen(true)} className="btn btn-sm cu-btn-green px-3">{TranslateString('Re-activate Shareholder')}</Button>
                                </Tooltip> 
                                }
                                { showShareholderDisable && 
                                <Tooltip className={`text-right`} title={TranslateString('Disable Shareholder')}>
                                    <Button type="button" onClick={() => setDisableOpen(true)} className="btn btn-sm cu-btn-green px-3">{TranslateString('Disable Shareholder')}</Button>
                                </Tooltip> 
                                }
                            </div>
                        </div>
                    </div>
                    
                </div>
                <div className="" >
                    <ul className="nav justify-content-left">
                        {
                            (()=>{
                                return menus.map(function(element,index){
                                    if(extLoading){
                                        return(
                                            <li  className={"nav-item tab-menu " + (element?.disableTab ? '' : 'cursor-pointer') }  key={index+'-tabs'} onClick={ element?.disableTab ? ()=> {} : ()=>props.selectTab(element?.key)} data-hide={element?.disableTab} >
                                                <div className="nav-link text-white fw-bold h5">
                                                    <span className={ (element.key===props?.selectedTab)?`active-tab text-dark`:( element?.disableTab ? `text-gray` : `text-dark`) }>
                                                        {intl.formatMessage({id: element?.label})}
                                                    </span>
                                                </div>
                                            </li>
                                        )
                                    } 
                                })
                            })()
                        }
                    </ul>
                </div>
            </div>

            <Modal
                open={isModalOpen}
                destroyOnClose
                footer={false}
                onCancel={() => setIsModalOpen(!isModalOpen)}
            >
                <Form
                    requiredMark={false}
                    // name={intl.formatMessage({ id: "Update Shareholder status" })}
                    onFinish={updateShareholderStatus}
                    layout="vertical"
                    initialValues={{}}
                >
                    <Form.Item
                        label={<><span>{intl.formatMessage({ id: convertToObjectKeyString("Reason") })}</span><span className="text-danger">*</span></>}
                        name="reason"
                        rules={[{ required: true, message: intl.formatMessage({ id: convertToObjectKeyString('Please input your Reason!') }) }]}
                        className="mb-1"
                    >
                        <Input.TextArea />
                    </Form.Item>
                    <div className="d-flex justify-content-end">
                        <Button type="reset" className="btn btn-sm bg-secondary px-4 border-secondary" onClick={props.handleReset}>{TranslateString('reset')}</Button>
                        &nbsp;
                        <Button type="submit" className="btn btn-sm cu-btn-green px-3">{TranslateString('Submit')}</Button>
                    </div>
                </Form>
            </Modal>

            <Modal
                title=""
                open={open}
                onOk={() => handleOk('enable')}
                okButtonProps={{ className: 'cu-bg-green rounded' }}
                okText={TranslateString('yes')}
                cancelText={TranslateString('no')}
                cancelButtonProps={{ className: 'cu-bg-green rounded' }}
                onCancel={handleCancelPop}
            >
                <p className='h5'>{TranslateString('do_you_want_to_re_activate_the_shareholder_analysis_of_the_housing_company')}</p>
            </Modal>

            <Modal
                title=""
                open={disableOpen}
                onOk={() => handleOk('disable')}
                okButtonProps={{ className: 'cu-bg-green rounded' }}
                okText={TranslateString('yes')}
                cancelText={TranslateString('no')}
                cancelButtonProps={{ className: 'cu-bg-green rounded' }}
                onCancel={handleCancelPop}
            >
                <p className='h5'>{TranslateString('do_you_want_to_disable_the_shareholder_analysis_of_the_housing_company')}</p>
            </Modal>

            <Modal
                open={updateDisableOpen}
                title={TranslateString("update_disable_duration")}
                onCancel={()=>setUpdateDisableOpen(false)}
                destroyOnClose
                footer={null}
            >
                <Form
                    form={disableMonthForm}
                    requiredMark={false}
                    name="control-ref"
                    onFinish={updateDisableDuration}
                    initialValues={{ disable_months: disabledMonths}}
                >
                    <Form.Item name="disable_months" label={<><span>{TranslateString('months')}</span><span className="text-danger">*</span></>}
                        rules={[
                            {
                                required: true,
                                message: TranslateString('Please enter number'),
                                pattern: new RegExp(/^[\d]+$/)
                            },
                        ]}
                    >
                        <Input min={1} max={3} disabled={loading} />
                    </Form.Item>
                    
                    <div className="d-flex justify-content-end">
                        <Button type="reset" className="btn btn-sm bg-secondary px-4 border-secondary" onClick={props.handleReset}>{TranslateString('reset')}</Button>
                        &nbsp;
                        <Button type="submit" className="btn btn-sm rounded-0 cu-btn-green px-3" >{!loading ? TranslateString('Submit') : TranslateString('Please wait')}</Button>
                    </div>
                </Form>
            </Modal>
        </>
    );
};
export default HousingCompanyDetailsTabs;